//=====================================================
//　歯科医院情報
//=====================================================
import { useEffect, useState } from "react";
import { AxiosResponse } from "axios";
import { getApiData } from "./CallApi";
import { ConstMsg } from "../utils/ConstMsg";
import { IFUseSystemErr } from "./UseSystemErr";

//歯科医院情報IF
export interface IFDataClinicInfo {
    id: string,
    name: string,
    subName: string,
    tel: string,
    postalCode: string,
    address: string,
    googleMapsUrl: string,
    clinicUrl: string,
    nearestTime: string,
    consultationHours: string,
    consultationHoursImage: string,
    closedDays: string,
    medicalItem: string,
    receiveSettingEmail: string,
    themeColor: string,
    gaTargetId: string,
    comment: {
        clinicComment1: string,
        clinicComment2: string,
        firstVisitDescription: string,
        returnVisitDescription: string,
        memoComment: string
    },
    imageUrls: string[],
    symptomsTitle: string,
    requireSymptoms: boolean,
    showWeeklyFirst: boolean
}

//歯科医院情報初期値定数
export const InitDataClinicInfo:IFDataClinicInfo = {
    id: "",
    name: "",
    subName: "",
    tel: "",
    postalCode: "",
    address: "",
    googleMapsUrl: "",
    clinicUrl: "",
    nearestTime: "",
    consultationHours: "",
    consultationHoursImage: "",
    closedDays: "",
    medicalItem: "",
    receiveSettingEmail: "",
    themeColor: "",
    gaTargetId: "",
    comment: {
        clinicComment1: "",
        clinicComment2: "",
        firstVisitDescription: "",
        returnVisitDescription: "",
        memoComment: ""
    },
    imageUrls: [],
    symptomsTitle: "",
    requireSymptoms: false,
    showWeeklyFirst: false
}

//歯科医院情報管理IF
export interface IFUseClinicInfo {
    data: IFDataClinicInfo,
}

//-----------------------------------------------------
//　歯科医院情報管理
//-----------------------------------------------------
export function useClinicInfo(clinicid:string, userr:IFUseSystemErr):IFUseClinicInfo{
    
    const [data, setData] = useState<IFDataClinicInfo>(InitDataClinicInfo);

    //医院情報取得
    useEffect(
        function(){
            if (clinicid) {
                let apiUrl = `/c/${clinicid}`;

                getApiData(
                    apiUrl, 
                    {},
                    function(res:AxiosResponse<any>){
                        if (res?.data) {
                            if (res.status === 200) {
                                let newData:IFDataClinicInfo = Object.assign({}, InitDataClinicInfo);
                                newData.id = res.data.id;
                                newData.name = res.data.name;
                                newData.subName = res.data.subName;
                                newData.tel = res.data.tel;
                                newData.postalCode = res.data.postalCode;
                                newData.address = res.data.address;
                                newData.googleMapsUrl = res.data.googleMapsUrl;
                                newData.clinicUrl = res.data.clinicUrl;
                                newData.nearestTime = res.data.nearestTime;
                                newData.consultationHours = res.data.consultationHours;
                                newData.consultationHoursImage = res.data.consultationHoursImage;
                                newData.closedDays = res.data.closedDays;
                                newData.medicalItem = res.data.medicalItem;
                                newData.receiveSettingEmail = res.data.receiveSettingEmail;
                                newData.themeColor = res.data.themeColor;
                                newData.gaTargetId = res.data.gaTargetId;
                                newData.comment.clinicComment1 = res.data.comment.clinicComment1;
                                newData.comment.clinicComment2 = res.data.comment.clinicComment2;
                                newData.comment.firstVisitDescription = res.data.comment.firstVisitDescription;
                                newData.comment.returnVisitDescription = res.data.comment.returnVisitDescription;
                                newData.comment.memoComment = res.data.comment.memoComment;
                                res.data.imageUrls.forEach(
                                    function(val: string){
                                        if (val) {
                                            newData.imageUrls.push(val);
                                        }
                                    }
                                );
                                newData.symptomsTitle = res.data.symptomsTitle;
                                newData.requireSymptoms = res.data.requireSymptoms;
                                newData.showWeeklyFirst = res.data.showWeeklyFirst;
                                setData(newData);
                            } else {
                                userr.setErrmess(res.data.message);
                            }
                        } else {
                            userr.setErrmess(ConstMsg.EG9990001);
                        }
                    }
                );
            } else {
                let newData:IFDataClinicInfo = Object.assign({}, InitDataClinicInfo);
                setData(newData);
            }
        },
        // エラーメッセージを更新するため、userrは第2引数から除外する
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [clinicid]
    );
    
    return { data }

}